// import MUI - React
import {
    Box,
    Paper,
    Typography,
    Button,
    Grid,
} from "@mui/material";
// Import Component
import RiepilogoComanda from "../components/RiepilogoComanda";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const ComandaCorrente = ({
    selectedTable,
    ordiniDivisi,
    ordiniFiltrati,
    ordineSchermo,
    ordiniUniti,
    checkboxSelectedIds,
    handleCheck,
    setOpenConfirmCloseCheckout,
    setOpenCloseInvoiceDialog,
    calcolaTotale,
    checkingSettings,
    closeCheckoutLabel,
    checkoutOrderSurchargeItems = [],
    checkoutOrderDiscountItems = [],
    checkoutGrossTotalValue = null,
    checkoutAppliedPrepaymentTotal = 0,
    checkoutAmountDue = null,
    checkoutPrepaymentsLoading = false,
    hideTotalPayment = false,
}) => {

    const { t } = useTranslation();
    const theme = useTheme();

    const getSelectionKey = (row) => {
        if (ordiniDivisi) return row.idSplit;
        if (row.isFixedPriceMenu) return `fixed-menu:${row.id}`;
        return row.isPackage ? `pkg:${row.id}` : `prd:${row.id}`;
    };

    function recuperaProdottiCheckbox(set) {
        if (checkoutAmountDue !== null) {
            return [{ quantity: 1, unitPrice: Number(checkoutAmountDue || 0) }];
        }
        const prodottiCheckBox = (ordiniDivisi ? ordineSchermo : ordiniUniti)?.filter((ord) =>
            set.has(getSelectionKey(ord))
        )
        return prodottiCheckBox;
    }
    return (
        <Box
            minHeight={"1px"}
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
            }}
        >
            <Paper
                sx={{
                    padding: 2,
                    overflow: "hidden",
                    marginBottom: 1,
                    borderRadius: "16px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: { xs: 220, md: 250, lg: 300 },
                }}
            >
                <RiepilogoComanda
                    selectedTable={selectedTable}
                    ordiniDivisi={ordiniDivisi}
                    ordiniFiltrati={ordiniFiltrati}
                    ordineSchermo={ordineSchermo}
                    ordiniUniti={ordiniUniti}
                    checkboxSelectedIds={checkboxSelectedIds}
                    handleCheck={handleCheck}
                    adjustmentItems={[...checkoutOrderSurchargeItems, ...checkoutOrderDiscountItems]}
                />
            </Paper>
            {/* Tasti pagamento */}
            <Paper sx={{
                py: 2,
                pl: 2.5,
                pr: 1,
                borderRadius: "16px",
                flexShrink: 0,
                position: { xs: "sticky", lg: "static" },
                bottom: 0,
                zIndex: 2,
            }}>
                {/* Conto totale */}
                <Box display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                    <Typography variant="h6" >
                        {(checkoutOrderSurchargeItems.length || checkoutOrderDiscountItems.length)
                            ? t("checkout_page.subtotal").toUpperCase()
                            : t("total").toUpperCase()}
                    </Typography>
                    <Typography variant="h6" color={theme.palette.mode === "light" ? "#125605" : "#78BD6A"}>
                        € {checkoutGrossTotalValue !== null
                            ? Number(checkoutGrossTotalValue || 0).toFixed(2)
                            : calcolaTotale(ordiniFiltrati)}
                    </Typography>
                </Box>
                {(checkoutOrderSurchargeItems?.length ? checkoutOrderSurchargeItems : []).map((item) => (
                    <Box key={item.orderId || item.label} display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                        <Typography color={theme.palette.mode === "light" ? "#303030" : "#B5B5B5"}>
                            {item.label || "Extra banco"}
                        </Typography>
                        <Typography color={theme.palette.mode === "light" ? "#125605" : "#78BD6A"}>
                            + EUR {Number(item.amount || 0).toFixed(2)}
                        </Typography>
                    </Box>
                ))}
                {(checkoutOrderDiscountItems?.length ? checkoutOrderDiscountItems : []).map((item) => (
                    <Box key={item.orderId || item.label} display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                        <Typography color={theme.palette.mode === "light" ? "#303030" : "#B5B5B5"}>
                            {item.label || "Sconto ordine"}
                        </Typography>
                        <Typography color={theme.palette.mode === "light" ? "#125605" : "#78BD6A"}>
                            - EUR {Number(item.amount || 0).toFixed(2)}
                        </Typography>
                    </Box>
                ))}
                {checkoutAppliedPrepaymentTotal > 0.009 && (
                    <Box display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                        <Typography color={theme.palette.mode === "light" ? "#303030" : "#B5B5B5"}>
                            {t("checkout_page.prepaymentsApplied")}
                        </Typography>
                        <Typography color={theme.palette.mode === "light" ? "#125605" : "#78BD6A"}>
                            - EUR {Number(checkoutAppliedPrepaymentTotal || 0).toFixed(2)}
                        </Typography>
                    </Box>
                )}
                {checkoutPrepaymentsLoading && (
                    <Box display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                        <Typography color={theme.palette.mode === "light" ? "#303030" : "#B5B5B5"}>
                            {t("checkout_page.prepaymentsLoading")}
                        </Typography>
                    </Box>
                )}
                {/* Conto da Pagare */}
                <Box display={"flex"} justifyContent={"space-between"} sx={{ ml: 1, mr: 2 }}>
                    <Typography color={theme.palette.mode === "light" ? "#303030" : "#B5B5B5"}>
                        {t("checkout_page.toPay")}
                    </Typography>
                    <Typography>
                        € {calcolaTotale(recuperaProdottiCheckbox(checkboxSelectedIds))}
                    </Typography>
                </Box>

                {/* Tasti gestione pagamento */}
                <Grid container display={"flex"} spacing={1.5} sx={{ width: "100%", marginTop: 1 }}>
                    <Grid item key={"cancel"} xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button fullWidth disabled={!selectedTable} variant="contained" sx={{
                            backgroundColor: theme.checkout.cancel_button.backgroundColor,
                            color: theme.checkout.color,
                            borderRadius: theme.checkout.borderRadius,
                            height: 48,
                        }}>{t("cancel")}</Button>
                    </Grid>
                    <Grid item key={"subtotal"} xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button fullWidth disabled={!selectedTable} variant="contained" sx={theme.checkout.subtotal_button}>{t("checkout_page.subtotal")}</Button>
                    </Grid>
                    <Grid item key={"createInvoice"} xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Button fullWidth disabled={!selectedTable} variant="contained"
                            onClick={() => {checkingSettings()}}
                            sx={theme.checkout.invoiceCheckout_button}>{t("checkout_page.printInvoice")}</Button>
                    </Grid>
                    {!hideTotalPayment && (
                        <Grid item key={"closeCheckout"} xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Button fullWidth disabled={!selectedTable} variant="contained"
                                onClick={() => setOpenConfirmCloseCheckout(true)}
                                sx={theme.checkout.closeCheckout_button}>{closeCheckoutLabel || t("checkout_page.closeCheckout")}</Button>
                        </Grid>
                    )}
                </Grid>
            </Paper>
        </Box>
    );
}
export default ComandaCorrente;
